import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './locales/tr';
import en from './locales/en';

/**
 * i18next kurulumu.
 *
 * Tek namespace ('translation') kullanilir; anahtarlar nokta yollu duz metindir
 * (orn. 'org.invite.roleStaff'). Mobil istemciyle ayni yapi.
 *
 * DIKKAT: i18next eksik anahtarda HATA VERMEZ, anahtarin kendisini basar.
 * Bunun tek gercek korumasi src/i18n/__tests__/keys.test.ts.
 */
void i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
  },
  lng: 'tr',
  fallbackLng: 'tr',
  interpolation: {
    // React zaten kacisliyor; iki kez kacislamak "&amp;" gibi metinler uretir.
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
